var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReadingTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75C6.89421 2.75 2.75 6.89421 2.75 12C2.75 17.1058 6.89421 21.25 12 21.25C17.1058 21.25 21.25 17.1058 21.25 12C21.25 6.89421 17.1058 2.75 12 2.75ZM1.25 12C1.25 6.06579 6.06579 1.25 12 1.25C17.9342 1.25 22.75 6.06579 22.75 12C22.75 17.9342 17.9342 22.75 12 22.75C6.06579 22.75 1.25 17.9342 1.25 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6289 6.75977C12.0431 6.75977 12.3789 7.09555 12.3789 7.50977V11.6098C12.3789 11.7633 12.4375 11.9859 12.5679 12.2145C12.6983 12.4431 12.8599 12.6067 12.9913 12.6845L12.9933 12.6857L12.9932 12.6857L16.0932 14.5357C16.4489 14.748 16.5652 15.2084 16.3529 15.5641C16.1407 15.9198 15.6803 16.0361 15.3246 15.8238L12.2266 13.975C12.2262 13.9748 12.2259 13.9746 12.2255 13.9744C11.8173 13.7322 11.4893 13.3511 11.2649 12.9576C11.0403 12.5637 10.8789 12.0862 10.8789 11.6098V7.50977C10.8789 7.09555 11.2147 6.75977 11.6289 6.75977Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingTime);
export default __webpack_public_path__ + "static/media/readingTime.f3ea53a6.svg";
export { ForwardRef as ReactComponent };